import { type ApolloClient } from 'apollo-client';
import type { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

type AtlassianStudioUserSiteContextOutput = {
	isRovoEnabled: boolean | null;
};

type GetIsRovoEnabledResponse = {
	atlassianStudio_userSiteContext: AtlassianStudioUserSiteContextOutput | null;
};

export const GET_IS_ROVO_ENABLED: DocumentNode = gql`
	query forgeGetIsRovoEnabled($cloudId: ID!) {
		atlassianStudio_userSiteContext(cloudId: $cloudId) {
			... on AtlassianStudioUserSiteContextOutput {
				isRovoEnabled
			}
		}
	}
`;

export const getIsRovoEnabled = async ({
	client,
	cloudId,
}: {
	client: ApolloClient<object>;
	cloudId: string;
}): Promise<boolean> => {
	try {
		const response = await client.query<GetIsRovoEnabledResponse>({
			query: GET_IS_ROVO_ENABLED,
			variables: { cloudId },
		});

		return response.data?.atlassianStudio_userSiteContext?.isRovoEnabled ?? false;
		// eslint-disable-next-line no-unused-vars
	} catch (err) {
		return false;
	}
};
